var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTipf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "tishi (2)") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.600000024
  }, /*#__PURE__*/React.createElement("g", {
    id: "Farm-Pools-LOCKED--",
    transform: "translate(-644.000000, -632.000000)",
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M651.8,632 C653.945023,632 655.894772,632.877929 657.308434,634.291586 C658.722098,635.705245 659.60003,637.654989 659.60003,639.8 C659.60003,641.945022 658.722101,643.894763 657.308442,645.308417 C655.894779,646.722075 653.945027,647.6 651.8,647.6 C649.654986,647.6 647.705241,646.722074 646.291582,645.308415 C644.877927,643.89476 644,641.945021 644,639.8 C644,637.65499 644.877931,635.705248 646.291589,634.291589 C647.705248,632.877931 649.65499,632 651.8,632 Z M651.8,633.240981 C649.996276,633.240981 648.356269,633.978432 647.167363,635.167344 C645.978459,636.356253 645.241011,637.996264 645.241011,639.8 C645.241011,641.603736 645.978459,643.243747 647.167363,644.432656 C648.356269,645.621568 649.996276,646.359019 651.8,646.359019 C653.603738,646.359019 655.24375,645.621569 656.43266,644.43266 C657.621569,643.24375 658.359019,641.603738 658.359019,639.8 C658.359019,637.996262 657.621569,636.35625 656.43266,635.16734 C655.24375,633.978431 653.603738,633.240981 651.8,633.240981 L651.8,633.240981 Z M652.420505,642.256395 L652.420505,643.497496 L651.179525,643.497496 L651.179525,642.256395 L652.420505,642.256395 Z M652.420505,636.102624 L652.420505,640.420505 L651.179525,640.420505 L651.179525,636.102624 L652.420505,636.102624 Z",
    id: "tishi-(2)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTipf);
export default __webpack_public_path__ + "static/media/tipf.caf452f847c2c0af48463b37d04a0111.svg";
export { ForwardRef as ReactComponent };